module.exports = __webpack_public_path__ + "static/img/hover5.83379441.png";